import React from 'react'

export default function SavedItems() {
  return (
    <div>SavedItems</div>
  )
}
